import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BreakpointService } from '../services/breakpoint.service';
import { TripAccessService } from '../services/trip-access/trip-access.service';
import { TripService } from '../services/trip.service';

/**
 * Interest page setup: desktop-width only, then lead on a standard trip.
 */
export const interestPageGuard: CanActivateFn = () => {
  const breakpointService = inject(BreakpointService);
  const router = inject(Router);
  const tripService = inject(TripService);
  const tripAccess = inject(TripAccessService);

  if (breakpointService.isMobile()) {
    return router.createUrlTree(['/desktop-required']);
  }

  if (!tripService.currentTripLoaded()) {
    return router.createUrlTree(['/group-management'], { fragment: 'interest-page' });
  }

  const trip = tripService.currentTrip.value();
  if (!tripAccess.context(trip)?.canAccessInterestPage) {
    return router.createUrlTree(['/dashboard']);
  }

  return router.createUrlTree(['/group-management'], { fragment: 'interest-page' });
};
